module.exports = __webpack_public_path__ + "img/kiss.d7763440.png";